<script setup>
/**
 * FormControlContentContentTargetContentArea
 * Fetches available content areas based on a selected target page.
 */
import {ref, computed, watch, onMounted} from 'vue'
import FormControlTypeSelect from '@/common/form-control-type/FormControlTypeSelect.vue'
import {usePageTemplatesContentAreasStore} from '@/stores/pageTemplatesContentAreas'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    }
})

const pageTemplatesContentAreasStore = usePageTemplatesContentAreasStore()

const options = ref([])

const targetPageId = computed(() => props.currentData.content__target_page)

const fetchContentAreas = async () => {
    const pageId = targetPageId.value

    if (!pageId) {
        options.value = []
        return
    }

    try {
        const contentAreas = await pageTemplatesContentAreasStore.getPagesContentAreas(pageId)

        options.value = (contentAreas || []).map(area => ({
            value: area,
            text: area
        }))
    } catch (error) {
        console.error('Failed to fetch content areas for page:', pageId, error)
        options.value = []
    }
}

onMounted(() => {
    fetchContentAreas()
})

watch(targetPageId, () => {
    fetchContentAreas()
})
</script>

<template>
    <FormControlTypeSelect v-bind="$props" v-if="options.length" :options="options"/>
</template>